import React, { Component } from "react";
import PropTypes from "prop-types";
import { logout, load } from "../../redux/modules/auth";
import { connect } from "react-redux";
import { deleteCookie } from "../../constants";

class NavBar extends Component {
  state = { activeItem: "dashboard" };
  static propTypes = {
    user: PropTypes.object,
    dispatch: PropTypes.func,
  };
  constructor(props) {
    super(props);
    this.logOut = this.logOut.bind(this);
  }
  componentWillMount() {
    const { dispatch } = this.props;
    dispatch(load());
  }
  logOut = () => {
    deleteCookie();
    const { dispatch } = this.props;
    dispatch(logout());
  };
  render() {
    const { user, isShow } = this.props;
    if (user && user.id && isShow) {
      return <React.Fragment />;
    } else {
      return null;
    }
  }
}

function mapStateToProps(state) {
  return {
    user: state.get("auth").get("user"),
  };
}

export default connect(mapStateToProps)(NavBar);
